export interface IDocumentRes {
    success: boolean;
    code: number;
    lead_document: iDocument[];
    client_document: iDocument[];
    employee_document: iDocument[];
    business_document: iDocument[];
}
export interface iDocument {
    id: string;
    created_date: string;
    name: string;
    url: string;
    person_id: string;
    checked?: boolean;
    program_id?: string;
    business_id?: string;
    creditor_id?: string;
    tag?: Tag | null;
}

export interface Tag {
    id: string;
    name: string;
    associated_date_format: string | null;
    associated_date: Date | [Date, Date] | null;
    frequency: string | null;
}

export const DOCUMENT_DATE_FORMAT = {
    MONTH_DAY_YEAR: "MM/DD/YYYY",
    YEAR: "YYYY",
    MONTH_YEAR: "MM/YYYY",
    RANGE_MONTH_DAY_YEAR: "MM/DD/YYYY-MM/DD/YYYY",
} as const;

export interface TagDetailsFormViewModel {
    tag_id?: string;
    associated_dates?: string[] | string[][];
    document_id?: string;
    program_id?: string;
    creditor_id?: string;
    business_id?: string;
}

export interface DocumentTagCatalog {
    id: string;
    name: string;
    associatedDateFormat: string | null;
    allowMultipleDates: boolean;
    assignableTo: string;
    fieldDateName: string;
    frequency: string | null;
    createdAt: Date;
    updatedAt: Date;
    isActive: boolean;
}